
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import PageHeader from '../components/common/PageHeader';
import ContactForm from '../components/contact/ContactForm';
import ChatbotUI from '../components/chatbot/ChatbotUI';

const Contact: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Contact ThinkTomorrow.AI | AI Consulting NZ</title>
        <meta name="description" content="Talk to ThinkTomorrow about AI adoption, workflow automation, and governed assistants for your New Zealand business. Phone, email, and enquiry form." />
        <link rel="canonical" href="https://thinktomorrow.ai/contact" />
        <meta property="og:title" content="Contact ThinkTomorrow.AI" />
        <meta property="og:description" content="Book a discovery call or send an enquiry about AI and workflow automation for NZ businesses." />
        <meta property="og:url" content="https://thinktomorrow.ai/contact" />
        <meta property="og:type" content="website" />
      </Helmet>
      <Navbar />
      <main className="min-h-screen pt-16 md:pt-24">
        <PageHeader 
          title="Connect With ThinkTomorrow.AI"
          subtitle="Have questions about how AI can help your New Zealand business? We're here to help."
        />
        <div className="py-8 md:py-12 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
            <ContactForm />
          </div>
        </div>
      </main>
      <Footer />
      <ChatbotUI />
    </>
  );
};

export default Contact;
